import { IOrganization } from '@iamexperiences/suite-header/lib-commonjs/SuiteHeader/SuiteHeader.types';
import { IAjaxCreationMethod } from '@microsoft/portal-app/lib/auth';
import { IAction } from '@microsoft/portal-app/lib/redux';
import {
  addAjaxEpic,
  getFailureActionType,
  getSuccessActionType,
} from '@microsoft/portal-app/lib/redux/createAjaxEpic';
import { settingsManager } from '../../../shared/settings';
import { AccountActions, IAccountState } from '../../models';
import { accountRegistry as registry } from '../accountRegistry';

const getOrganizationsUrl = {
  url: `${settingsManager.get('myAccountBackendUrl')}/api/organizations`,
  audience: settingsManager.getRequired('clientId'),
};

export const getOrganizationsAjax = (ajax: IAjaxCreationMethod) => {
  return ajax.getJSON(getOrganizationsUrl);
};

// TODO: Update the IOrganization interface in suite-header library to match the account-organizations library
export const getOrganizationsSuccess = (state: IAccountState, action: IAction<IOrganization[]>): IAccountState => {
  if (!action.payload) {
    return state;
  }

  const res = action.payload;
  return {
    ...state,
    organizations: {
      isLoading: false,
      value: res,
    },
  };
};

export const getOrganizationsFailed = (state: IAccountState, action: IAction<string>): IAccountState => {
  if (!action.payload) {
    return state;
  }

  return {
    ...state,
    hasError: true,
  };
};

addAjaxEpic(registry, AccountActions.getOrganizations, getOrganizationsAjax);
registry.add(getSuccessActionType(AccountActions.getOrganizations), getOrganizationsSuccess);
registry.add(getFailureActionType(AccountActions.getOrganizations), getOrganizationsFailed);
